module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dy-item-wrap', {
    attrs: {
      "item": _vm.item
    }
  }, [_c('el-switch', _vm._g(_vm._b({}, 'el-switch', _vm.$attrs, false), _vm.$listeners))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34ceb606"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DynamicForm/widgets/SwitchWidget.vue
// module id = 715
// module chunks = 20